import { useEffect } from 'react'
import { useLocation } from 'react-router'
import qs from 'qs'
import { loginUserExchangeToken } from 'services/AuthService'
import LocalStorageService from 'services/LocalStorageService'
import { KEYS } from 'utils/localStorage'
import { redirect } from 'utils/paths'
import { fetchAuthUserRoutine } from 'features/auth/ducks/actions'
import { useDispatch } from 'react-redux'
import { homePathFor, takeStoredRedirect } from 'utils/postLoginDestination'

const LoginCallback = () => {
  const { search } = useLocation()
  const dispatch = useDispatch()

  const params = qs.parse(search || '', { ignoreQueryPrefix: true })

  const { ott } = params

  useEffect(() => {
    if (typeof ott === 'string') {
      loginUserExchangeToken({ ott })
        .then(resp => {
          LocalStorageService.set(KEYS.token, resp.data.data.token)
          const destination = takeStoredRedirect() || homePathFor(null)

          dispatch(fetchAuthUserRoutine())

          setTimeout(() => {
            redirect(destination)
          }, 500)
      })
    }
  }, [ott])

  return null
}

export default LoginCallback
